import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { doc, getDoc, updateDoc, query, where, collection, getDocs } from "firebase/firestore";
import { db } from "../utils/firebase";
import EventSignupQuestions from "./EventSignupQuestions";

export default function ViewSignupAnswersDialog({ open, onClose, eventId, userId, eventMode }) {
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [participantId, setParticipantId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    // Fetch participant doc (current model: participants collection holds answers)
    (async () => {
      try {
        const q = query(collection(db, 'participants'), where('eventId', '==', eventId), where('userId', '==', userId));
        const snap = await getDocs(q);
        if (!snap.empty) {
          const d = snap.docs[0];
            setParticipantId(d.id);
            const data = d.data();
            setAnswers(data.answers || {});
        } else {
          // user has no participant doc yet -> start with empty answers object
          setParticipantId(null);
          setAnswers({});
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [open, eventId, userId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>My Signup Form</DialogTitle>
      <DialogContent>
        {loading ? "Loading..." : (
          <EventSignupQuestions
            values={answers}
            onChange={editing ? (e => {
              const { name, value, type, checked } = e.target;
              setAnswers(a => ({ ...a, [name]: type === 'checkbox' ? checked : value }));
            }) : undefined}
            readOnly={!editing}
          />
        )}
      </DialogContent>
      <DialogActions>
        {!editing && (eventMode === 'signups' || eventMode === 'limited-signups') && (
          <Button onClick={() => setEditing(true)} disabled={loading}>Edit</Button>
        )}
        {editing && (
          <>
            <Button
              onClick={async () => {
                if (!participantId) { setEditing(false); return; }
                if (!answers?.agreementAccepted) { return; }
                setSaving(true);
                try { await updateDoc(doc(db, 'participants', participantId), { answers }); setEditing(false); } catch(e) { /* noop */ }
                setSaving(false);
              }}
              disabled={saving || !answers?.agreementAccepted}
              variant="contained"
            >
              {saving ? 'Saving...' : 'Save'}
            </Button>
            <Button onClick={() => { setEditing(false); }} disabled={saving}>Cancel</Button>
          </>
        )}
        <Button onClick={onClose} disabled={saving}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
